<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view v-slot="{ Component, route }">
          <component :is="Component" :key="route.name" />
        </router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { isTags } from "@/utils/tags";

export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // },
    cachedViews() {
      // console.log(this.$store.getters.tagsViewList.map((x) => x.name));
      return this.$store.getters.tagsViewList.map((x) => x.name);
    }
  },
  /**
   * 监听路由变化
   */
  watch:{
    '$route': {
      handler(to, from) {
        // console.log(from, to)
        if (!isTags(to.path)) return;
        const { fullPath, meta, name, params, path, query } = to;
        this.$store.commit("addTagsViewList", {
          fullPath,
          meta,
          name,
          params,
          path,
          query,
          title: this.getTitle(to)
        });
       
      },
      immediate: true
    }
    
  },
  methods: {
    /**
     * 生成 title
     */
    getTitle(route) {
      let title = "";
      if (!route.meta) {
        // 处理无 meta 的路由
        const pathArr = route.path.split("/");
        title = pathArr[pathArr.length - 1];
      } else {
        title = route.meta.title;
      }
      return title;
    }
  }
  
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue